<mat-card
  *ngIf="!isSuccessMessageVisible"
  appearance="outlined"
  class="create-ticket-form u-w--100">
  <mat-card-title class="u-pb--large ticket-form-title-wrapper">
    <div>{{ localizationConstants.TECH_COVER_CREATE_TICKET_TITLE | translate }}</div>
    <div
      *ngIf="selectedProduct() as product"
      class="contract-label">
      {{ localizationConstants.TECH_COVER_CREATE_TICKET_CONTRACT_NUMBER | translate }}:
      {{ product.contractNumber }}
    </div>
  </mat-card-title>

  <form
    [formGroup]="ticketForm"
    class="u-flex-column gap-lg">
    <mat-form-field
      class="full-width"
      #titleField>
      <mat-label>{{
        localizationConstants.TECH_COVER_CREATE_TICKET_ISSUE_TITLE | translate
      }}</mat-label>
      <input
        matInput
        formControlName="issueTitle"
        required />
      <mat-error>
        <app-form-field-error [control]="ticketForm.controls['issueTitle']"></app-form-field-error>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>{{
        localizationConstants.TECH_COVER_CREATE_TICKET_ISSUE_DESCRIPTION | translate
      }}</mat-label>
      <textarea
        matInput
        formControlName="issueDescription"
        rows="4"
        required></textarea>
      <mat-error>
        <app-form-field-error
          [control]="ticketForm.controls['issueDescription']"></app-form-field-error>
      </mat-error>
    </mat-form-field>

    <!-- TODO: Add when the feature is ready on backend -->
    <!-- <mat-form-field class="u-w--100">
      <mat-label>{{
        localizationConstants.TECH_COVER_CREATE_TICKET_BUSINESS_IMPACT | translate
      }}</mat-label>
      <mat-select formControlName="businessImpact">
        <mat-option
          *ngFor="let option of businessImpactOptions()"
          [value]="option"
          >{{ option }}</mat-option
        >
      </mat-select>
    </mat-form-field> -->

    <h2 class="mat-h2">
      {{ localizationConstants.TECH_COVER_CREATE_TICKET_PRODUCT_IMPACT | translate }}
    </h2>

    <div class="grid grid-cols-1 grid-cols-md-2 gap-md">
      <mat-form-field class="u-w--100">
        <mat-label>{{
          localizationConstants.TECH_COVER_CREATE_TICKET_SELECT_PRODUCT_WITH_ISSUES | translate
        }}</mat-label>
        <mat-select
          formControlName="productWithIssue"
          required>
          <mat-option
            *ngFor="let option of productOptions()"
            [value]="option.id"
            >{{ option.name }}</mat-option
          >
        </mat-select>
        <mat-error>
          <app-form-field-error
            [control]="ticketForm.controls.productWithIssue"></app-form-field-error>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="u-w--100">
        <mat-label>{{
          localizationConstants.TECH_COVER_CREATE_TICKET_SELECT_PRODUCT_RELEASE | translate
        }}</mat-label>
        <mat-select
          formControlName="productRelease"
          required>
          <mat-option
            *ngFor="let option of productVersionOptions()"
            [value]="option.id"
            >{{ option.name }}</mat-option
          >
        </mat-select>
        <mat-error>
          <app-form-field-error
            [control]="ticketForm.controls.productRelease"></app-form-field-error>
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field class="u-w--100">
      <mat-label>{{
        localizationConstants.TECH_COVER_CREATE_TICKET_LOCAL_PRIORITY | translate
      }}</mat-label>
      <mat-select
        formControlName="localPriority"
        required>
        <mat-option
          *ngFor="let option of priorityOptions"
          [value]="option.value"
          >{{ option.label | translate }}</mat-option
        >
      </mat-select>
      <mat-error>
        <app-form-field-error [control]="ticketForm.controls.localPriority"></app-form-field-error>
      </mat-error>
    </mat-form-field>

    <!-- TODO: Add when the feature is ready on backend and salesforce -->
    <!-- <h2 class="mat-h2">
      {{ localizationConstants.TECH_COVER_CREATE_TICKET_SUPPORTING_DOCUMENTS | translate }}
    </h2>

    <drag-n-drop (file)="onFileChange($event)"></drag-n-drop> -->

    <div class="button-row">
      <button
        type="button"
        (click)="onCancel()"
        class="button button-secondary">
        {{ localizationConstants.BUTTON_CANCEL | translate }}
      </button>
      <button
        (click)="onSubmitAsync()"
        class="button button-primary">
        {{ localizationConstants.BUTTON_SUBMIT_REQUEST | translate }}
      </button>
    </div>
  </form>
</mat-card>
<div
  *ngIf="isSuccessMessageVisible"
  class="success-card-container">
  <mat-card
    appearance="outlined"
    class="c-col-12 c-col-md-6 c-col-lg-4">
    <div class="u-w--100 flex gap-md u-content-center u-mt--large">
      <div class="success-icon-border u-mt--medium">
        <mat-icon
          class="icon-size-xxxl"
          svgIcon="checkmark"></mat-icon>
      </div>
    </div>
    <mat-card-header class="u-mb--large">
      <div class="u-w--100">
        <mat-card-title class="u-text-center"
          >{{ localizationConstants.SUCCESS_TITLE | translate }}!</mat-card-title
        >
      </div>
    </mat-card-header>
    <mat-card-content>
      <div class="flex u-flex-column align-center gap-lg">
        <p>
          {{
            localizationConstants.TECH_COVER_CREATE_TICKET_SUCCESS_MESSAGE_TITLE
              | translate: { ticketNumber }
          }}
        </p>
        <h2 class="mat-h2 subtitle">
          <strong>
            {{
              localizationConstants.TECH_COVER_CREATE_TICKET_SUCCESS_MESSAGE_WHAT_HAPPENS_NOW_TITLE
                | translate
            }}
          </strong>
        </h2>
        <p>
          {{
            localizationConstants.TECH_COVER_CREATE_TICKET_SUCCESS_MESSAGE_WHAT_HAPPENS_NOW_CONTRACT_CUSTOMER_DESCRIPTION
              | translate
          }}
          <strong>{{ localizationConstants.TIME_VALUE_HOURS | translate: { hours: 3 } }}</strong
          >.
        </p>
      </div>
      <button
        type="button"
        (click)="onSuccessMessageClose()"
        class="button button-block button-primary u-mt--large">
        {{ localizationConstants.BUTTON_BACK_TO_HOME | translate }}
      </button>
    </mat-card-content>
  </mat-card>
</div>
